import React from 'react';

export const IdIcon = ({height = 27, width = 26, stroke = "var(--urtentic-sdk-body, #737373)"}) => {

    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 8.99988H18" stroke={stroke} strokeWidth="1.3125" strokeLinecap="round"/>
            <path d="M14 12.4999H17" stroke={stroke} strokeWidth="1.3125" strokeLinecap="round"/>
            <path
                d="M17 2.99988H7C4.23858 2.99988 2 5.23845 2 7.99988V15.9999C2 18.7613 4.23858 20.9999 7 20.9999H17C19.7614 20.9999 22 18.7613 22 15.9999V7.99988C22 5.23845 19.7614 2.99988 17 2.99988Z"
                stroke={stroke} strokeWidth="1.3125" strokeLinejoin="round"/>
            <path d="M5 15.9999C6.20831 13.4188 10.7122 13.249 12 15.9999" stroke={stroke} strokeWidth="1.3125"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M10.5 8.99988C10.5 10.1044 9.60457 10.9999 8.5 10.9999C7.39543 10.9999 6.5 10.1044 6.5 8.99988C6.5 7.89531 7.39543 6.99988 8.5 6.99988C9.60457 6.99988 10.5 7.89531 10.5 8.99988Z"
                stroke={stroke} strokeWidth="1.3125"/>
        </svg>
    )
};